import { useState } from 'react'
import { gql } from 'graphql-request'
import { Link } from 'react-router-dom'

import { useQuery } from '@hooks/graphql'
import Breadcrumbs from '@components/Breadcrumbs'
import SegmentedControl from '@components/SegmentedControl'
import NoResults from './NoResults'
import Spinner from '@components/Spinner'
import EducatorProfilePicture from '@components/EducatorProfilePicture'

const CLASSROOMS_QUERY = gql`
  query enrolledClassrooms($archived: Boolean) {
    enrolledClassrooms(archived: $archived) {
      id
      name
      educator {
        fullName
        profileImage {
          url
        }
      }
    }
  }
`

const ClassroomList = () => {
  const [archived, setArchived] = useState(false)

  const { isLoading, data: { enrolledClassrooms = [] } = {} } = useQuery({
    queryKey: ['enrolledClassrooms', archived],
    gqlQuery: CLASSROOMS_QUERY,
    variables: { archived }
  })

  return (
    <>
      <Breadcrumbs>
        <Breadcrumbs.Link label='Classrooms' to='/students/classrooms' />
      </Breadcrumbs>

      <div className='px-5 py-6'>
        <h1 className='text-2xl font-semibold text-primary'>Classrooms</h1>
        <div className='my-4'>
          <SegmentedControl
            options={[
              { label: 'Active', value: false },
              { label: 'Archived', value: true }
            ]}
            value={archived}
            onChange={(value) => setArchived(value)}
          />
        </div>
        <Choose>
          <When condition={isLoading}>
            <Spinner className='relative top-0 left-0 flex items-center justify-center w-full h-full' />
          </When>
          <When condition={!isLoading && enrolledClassrooms.length > 0}>
            <div className='mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
              <For each='classroom' index='index' of={enrolledClassrooms}>
                <Link
                  key={classroom.id}
                  to={`/students/classrooms/${classroom.id}`}
                  className='flex flex-col gap-2 border border-[#E2E8F0] rounded-lg p-4'
                >
                  <div className='text-xl line-clamp-1'>
                    {classroom.name}
                  </div>
                  <div className='test-sm pt-4 border-t border-[#E2E8F0] border-dashed line-clamp-1 flex gap-2 items-center'>
                    <EducatorProfilePicture id={classroom.educator?.id} url={classroom.educator?.profileImage?.url} fullName={classroom.educator?.fullName} />
                    <div>{classroom.educator?.fullName}</div>
                  </div>
                </Link>
              </For>
            </div>
          </When>
          <When condition={enrolledClassrooms.length === 0}>
            <NoResults archived={archived} />
          </When>
        </Choose>
      </div>
    </>
  )
}

export default ClassroomList
